@import '../../styles/variables.scss';
@import '../../styles/breakpoints.scss';

.container {
  @include breakpoint-up(md) {
    padding-left: $sidebar-width;
  }
}
